import { privateRequest } from "../apiConfig/privateRequest";

//fetch master
export const masterFetchData =async(url,payload) => {
    const result = await privateRequest.get(`/${url}?search=${encodeURIComponent(payload.searchValue)}&pageNo=${payload.pageNo}&size=${payload.pageSize}`) 
    return result
}

//fetch project
export const fetchAllProjectData = (userId,searchValue,pageNo,pageSize) => {
    return privateRequest.get(`/project/admin/${userId}?search=${searchValue}&pageNo=${pageNo}&size=${pageSize}`)
}

//fetch Date
export const userFetchDate =async(url,payload) => {
    const result = await privateRequest.get(`/${url}/getByJoinDate?from=${payload.from}&to=${payload.to}`) 
    return result
}


export const createdCVFetchData =async(url,payload) => {
    const result = await privateRequest.get(`https://cvmaker.nimapinfotech.com/api/${url}?search=${encodeURIComponent(payload.searchValue)}&pageNo=${payload.pageNo}&size=${payload.pageSize}`) 
    return result
}

// searchValue,pageNo,pageSize